import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { AutoComplete } from "antd";
import convertToExcel from "../../../../components/ExportToExcel";

const FarmerNLCReport = () => {
  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [seasonlist, setSeasonlist] = useState(null);
  const [seasonId, setSeasonId] = useState();

  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();

  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [expandedGroups, setExpandedGroups] = useState({});
  useEffect(() => {
    const initialState = {};
    Object.keys(activityStructure).forEach((heading) => {
      initialState[heading] = true;
    });
    setExpandedGroups(initialState);
  }, [data]);
  const toggleGroup = (heading) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [heading]: !prev[heading],
    }));
  };

  const { sendRequest: getprocurementData } = useHttp();

  // const fillprocurementData = (e) => {
  //   if (e) e.preventDefault();

  //   var urlfilter = "";

  //   if (employeeId > 0) {
  //     urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
  //   }

  //   if (seasonId > 0) {
  //     urlfilter = urlfilter + `&seasonId=${seasonId}`;
  //   }

  //   if (ranchId > 0) {
  //     urlfilter = urlfilter + `&ranchId=${ranchId}`;
  //   }

  //   if (farmerNumber) {
  //     urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
  //   }

  //   var url = `/api/farmerNlcReport/?orgId=${localStorage.getItem(
  //     "orgId"
  //   )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

  //   getprocurementData(
  //     {
  //       url: url,
  //     },
  //     (data) => {
  //       setData(data);
  //     }
  //   );
  // };

  const fillprocurementData = (e) => {
    if (e) e.preventDefault();

    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }

    if (farmerNumber) {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }

    var url = `/api/farmerNlcReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillprocurementData();
  }, [getprocurementData]);

  const handleExportExcel = () => {
    const filename = "FarmerNLCReport.xlsx";

    // Base columns
    const fieldsToExport = [
      "Farmer Id",
      "farmerName",
      "Crop",
      "Field Category",
      "Field ID",
      "Extension Officer",
      "Field Size",
    ];

    // Dynamic columns based on activities
    Object?.entries(activityStructure)?.forEach(([heading, subs]) => {
      subs?.forEach((_, idx) => {
        fieldsToExport?.push(`${heading}_${idx}`);
      });
    });

    // Add Total Score and Percentage at the end
    fieldsToExport?.push("totalScore", "percentage");

    // Prepare export data
    const exportData = data?.map((itm) => {
      const row = {
        farmerId: itm.farmerNo,
        farmerName: itm.farmerName,
        crop: itm.cropName,
        fieldCategory: itm.ranchName,
        fieldId: itm.fieldCode,
        extensionOfficer: itm.executiveName,
        fieldSize: itm.plotArea,
      };

      Object?.entries(activityStructure)?.forEach(([heading, subs]) => {
        const act = itm.activities?.find((a) => a.mainHeading === heading);
        const totalAmounts = act?.subHeadings || [];

        subs.forEach((subLabel, idx) => {
          let totalAmount = "0.00";

          if (heading === "Farm Management") {
            const match = totalAmounts?.find((r) => r.activity === subLabel);
            totalAmount = match?.totalAmount ?? "0.00";
          } else {
            totalAmount = totalAmounts[idx]?.totalAmount ?? "0.00";
          }

          row[`${heading}_${idx}`] = totalAmount;
        });
      });

      row.totalScore = itm.totalScore;
      row.percentage = itm.percentage;

      return row;
    });

    // Create custom headers for better readability
    const customHeaders = [
      "Farmer Id",
      "Farmer Name",
      "Crop",
      "Field Category",
      "Field ID",
      "Extension Officer",
      "Field Size",
      ...Object?.entries(activityStructure)?.flatMap(([heading, subs]) =>
        subs?.map((sub) => `${heading} - ${sub}`)
      ),
      "Total Score",
      "Percentage (%)",
    ];

    convertToExcel(exportData, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const activityStructure = {};

  data?.forEach((item) => {
    item.activities?.forEach((act) => {
      const key = act.mainHeading;

      if (!activityStructure[key]) {
        activityStructure[key] = [];
      }

      act.subHeadings.forEach((sub, idx) => {
        const label =
          act.mainHeading === "Farm Management"
            ? sub.activity // use activity name like Sowing
            : `${key} ${idx + 1}`; // otherwise, use heading 1, 2

        if (!activityStructure[key].includes(label)) {
          activityStructure[key].push(label);
        }
      });
    });
  });

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    if (!employeeId || isNaN(employeeId)) return;
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    data && farmerNumber
      ? data
          .map((item) => item.farmerNo)
          .filter((no) => no.toLowerCase().includes(farmerNumber.toLowerCase()))
          .map((no) => ({ value: no }))
      : [];

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Farmer NLC Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          {" "}
          <form onSubmit={fillprocurementData}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Season</label>
                    <select
                      id="season"
                      className="form-control"
                      value={seasonId}
                      onChange={(e) => {
                        setSeasonId(e.target.value || 0);
                        setData([]);
                      }}
                      // required
                    >
                      <option value="">Select</option>
                      {seasonlist &&
                        seasonlist.map((x) => (
                          <option key={x.seasonId} value={x.seasonId}>
                            {x.seasonName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>Ranch</label>
                    <select
                      id="ranch"
                      className="form-control"
                      value={ranchId}
                      onChange={(e) => {
                        setRanchId(e.target.value || 0);
                        setData([]);
                      }}
                    >
                      <option value="">Select</option>
                      {ranchData &&
                        ranchData.map((x) => (
                          <option key={x.ranchId} value={x.ranchId}>
                            {x.ranchName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>{"Field Officer"}</label>
                    <select
                      id="emp_id"
                      className="form-control"
                      ref={(el) => (frmRef.current["emp_id"] = el)}
                      value={employeeId}
                      onChange={(e) => {
                        setEmployeeId(e.target.value || 0);
                        setData([]);
                      }}
                    >
                      <option value={0}>Select</option>
                      {employeeData &&
                        employeeData.map((x) => (
                          <option
                            key={x.userId}
                            user-id={x.userId}
                            value={x.userId}
                          >
                            {x.employeeName}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="farmer_number">Farmer Number</label>
                  <AutoComplete
                    className="form-control"
                    style={{ height: "30px" }}
                    value={farmerNumber}
                    options={filteredOptions}
                    placeholder="Farmer Number"
                    onChange={(value) => setFarmerNumber(value)}
                    onSelect={(value) => setFarmerNumber(value)}
                  />
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <button className="form-control btn btn-sm btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </div>{" "}
            </div>{" "}
          </form>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {currentItems.length > 0 ? (
                    <>
                      <div className="card-body">
                        <table className="table table-bordered table-responsive text-center">
                          <thead>
                            <tr className="tableheaderrowview">
                              <th colSpan={8}>Farmer Details</th>

                              {Object.entries(activityStructure).map(
                                ([heading, subs]) => (
                                  <th
                                    key={heading}
                                    colSpan={
                                      expandedGroups[heading] ? subs.length : 1
                                    }
                                    style={{ cursor: "pointer" }}
                                    onClick={() => toggleGroup(heading)}
                                  >
                                    {heading}{" "}
                                    {expandedGroups[heading] ? "-" : "+"}
                                  </th>
                                )
                              )}

                              <th rowSpan={2}>Total Score</th>
                              <th rowSpan={2}>Percentage</th>
                            </tr>
                            <tr className="table-subheader">
                              <th>Farmer Id</th>
                              <th>Farmer Name</th>
                              <th>Season Name</th>
                              <th>Crop</th>
                              <th>Field Category</th>
                              <th>Field ID</th>
                              <th>Extension Officer </th>
                              <th>Field Size </th>

                              <th>Plot Size Unit</th>
                              <th>Executive Name</th>
                              <th>Season Name</th> 
                              {Object.entries(activityStructure).flatMap(
                                ([heading, subs]) =>
                                  expandedGroups[heading] ? (
                                    // Expanded → show all subcolumns
                                    subs.map((subLabel, idx) => (
                                      <th key={`${heading}_${idx}`}>
                                        {subLabel}
                                      </th>
                                    ))
                                  ) : (
                                    // Collapsed → show only one column with sum
                                    <th key={`${heading}_collapsed`}>
                                      {subs.reduce(
                                        (acc, val) => acc + (Number(val) || 0),
                                        0
                                      )}
                                    </th>
                                  )
                              )}
                            </tr>
                          </thead>

                          <tbody>
                            {currentItems.map((itm, i) => (
                              <tr key={i}>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.seasonName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.ranchName}</td>
                                <td>{itm.fieldCode}</td>
                                <td>{itm.executiveName}</td>
                                <td>{formatNumber(itm.plotArea)}</td>{" "}
                                {/* numeric formatted */}
                                {Object.entries(activityStructure).flatMap(
                                  ([heading, subs]) => {
                                    const act = itm.activities?.find(
                                      (a) => a.mainHeading === heading
                                    );
                                    const totalAmounts = act?.subHeadings || [];

                                    if (expandedGroups[heading]) {
                                      // Expanded: show each subheading value
                                      return subs.map((subLabel, idx) => {
                                        let totalAmount = "0.00";

                                        if (heading === "Farm Management") {
                                          const match = totalAmounts.find(
                                            (r) => r.activity === subLabel
                                          );
                                          totalAmount =
                                            match?.totalAmount ?? "0.00";
                                        } else {
                                          totalAmount =
                                            totalAmounts[idx]?.totalAmount ??
                                            "0.00";
                                        }

                                        // ✅ check if numeric
                                        const isNumeric =
                                          !isNaN(parseFloat(totalAmount)) &&
                                          isFinite(totalAmount);

                                        return (
                                          <td key={`${i}_${heading}_${idx}`}>
                                            {isNumeric
                                              ? formatNumber(totalAmount)
                                              : totalAmount}
                                          </td>
                                        );
                                      });
                                    } else {
                                      // Collapsed: show sum of all subheading values
                                      let sum = 0;
                                      totalAmounts.forEach((r) => {
                                        if (r.totalAmount) {
                                          sum += Number(r.totalAmount);
                                        }
                                      });

                                      return (
                                        <td key={`${i}_${heading}_collapsed`}>
                                          {formatNumber(sum)}
                                        </td>
                                      );
                                    }
                                  }
                                )}
                                <td>{formatNumber(itm.totalScore)}</td>{" "}
                                {/* numeric formatted */}
                                <td>{formatNumber(itm.percentage)}%</td>{" "}
                                {/* numeric formatted */}
                              </tr>
                            ))}
                          </tbody>
                        </table> 
                      </div>
                      <div className="card-footer clearfix">
                        <Pagination
                          totalItems={data.length}
                          itemsPerPage={itemsPerPage}
                          onPageChange={paginate}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                        />
                      </div>
                    </>
                  ) : (
                    <p className="text-center">No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerNLCReport;
